<template>
  <div class="bootstrap-wrapper">
    <div class="container">
      <transition name="slide-fade">
        <div v-if="showOffCanvas" id="off-canvas-container" class="sidenav">
          <div
            id="dialog-profile"
            class="row mx-0"
            data-off-canvas
            data-position="right"
          >
            <div class="col-12 px-0">
              <div
                class="top-bar kal-navigation-bar elevation-0 row m-0"
                style="position: relative;"
                id="example-menu"
              >
                <div class="top-bar-left">
                  <ul class="menu">
                    <li>
                      <a
                        class="justify-center align-center row"
                        data-open="dialog-profile"
                      >
                        <div
                          class="kal-navigation-link kal-navigation-link__avatar"
                        >
                          <unicon
                            name="user-circle"
                            width="70"
                            height="70"
                            :fill="grayCol"
                            v-if="userData && !userData.avatar"
                          />
                          <img
                            width="70"
                            height="70"
                            :src="
                              require(`@/assets/avatar/Avatar ${userData.avatar}/Avatar-${userData.avatar}.gif`)
                            "
                            class="avatar-img transition-all"
                            v-if="userData && userData.avatar"
                          />
                        </div>
                        <span class="dots dots-vertical"></span>
                      </a>
                    </li>
                  </ul>
                </div>
                <div
                  @click="toggleOffCanvas(false)"
                  class="close-off-panel-button"
                >
                  <div class="elevation-1 text-primary">
                    <i class="fa fa-arrow-left"></i>
                  </div>
                  <span class="text-gray">{{ $t("back") }}</span>
                </div>
              </div>
              <div id="profile-items">
                <div class="row mx-0 my-2">
                  <div class="col-10 row align-center">
                    <div class="col-2 text-center">
                      <unicon name="globe" :fill="secCol"></unicon>
                    </div>
                    <div class="col-8">
                      <div class="row text-barlow-condensed subtitle text-dark">
                        {{ $t("language") }}
                      </div>
                      <div class="row text-barlow-condensed subtitle-2">
                        Cambiar lenguage de la plataforma
                      </div>
                    </div>
                  </div>
                  <div class="col-2 py-3 text-right px-0">
                    <LanguageSwitcher />
                  </div>
                </div>
                <br />

                <div class="row mx-0">
                  <div class="col-10 row align-center">
                    <div class="col-2 text-center">
                      <unicon name="user" :fill="secCol"></unicon>
                    </div>
                    <div class="col-8">
                      <div class="row text-barlow-condensed subtitle text-dark">
                        {{ $t("profile") }}
                      </div>
                      <div class="row text-barlow-condensed subtitle-2">
                        Elegir avatar, cambiar correo de contacto
                      </div>
                    </div>
                  </div>
                  <div class="col-2 px-0 text-right ml-n5">
                    <div class="button-container px-0">
                      <button
                        class="button secondary py-2 font-20 my-2"
                        @click="showModal.profile = true"
                      >
                        {{ $t("configure") }}
                      </button>
                    </div>
                  </div>
                </div>
                <!-- <br />
                <div class="row mx-0">
                  <div class="col-10 row align-center">
                    <div class="col-2 text-center">
                      <unicon name="graduation-hat" :fill="secCol"></unicon>
                    </div>
                    <div class="col-8">
                      <div class="row text-barlow-condensed subtitle text-dark">
                        {{ $t("courses") }}
                      </div>
                      <div class="row text-barlow-condensed subtitle-2">
                        {{ $t("course_text") }}
                      </div>
                    </div>
                  </div>

                  <div class="col-2 px-0 ml-n5">
                    <div class="button-container px-0">
                      <button class="button secondary py-2 font-20 my-2">
                        {{ $t("configure") }}
                      </button>
                    </div>
                  </div>
                </div> -->
                <br />
                <div class="row mx-0">
                  <div class="col-10 row align-center">
                    <div class="col-2 text-center">
                      <unicon name="file-download-alt" :fill="secCol"></unicon>
                    </div>
                    <div class="col-8">
                      <div class="row text-barlow-condensed subtitle text-dark">
                        Descargar Reporte por mes
                      </div>
                      <div class="row text-barlow-condensed subtitle-2">
                        Seleccione un curso para descargar reporte por mes
                      </div>
                    </div>
                  </div>
                  <div class="row px-0">
                    <div class="col-2 text-right">
                      <div class="button-container px-0">
                        <button
                          class="button secondary py-2 font-20 my-2"
                          @click="showModal.reports = true"
                        >
                          Ver
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <br v-if="quantiyPendingReports > 0" />
                <div class="row mx-0" v-if="quantiyPendingReports > 0">
                  <div class="col-10 row align-center">
                    <div class="col-2 text-center">
                      <unicon name="file-download-alt" :fill="secCol"></unicon>
                    </div>
                    <div class="col-8">
                      <div class="row text-barlow-condensed subtitle text-dark">
                        <span>Reporte mensual Pendiente</span>
                        <div
                          class="badge badge-danger mx-3 p-2 rounded d-flex justify-content-center align-items-center"
                        >
                          <span class="font-2-em">{{
                            quantiyPendingReports
                          }}</span>
                        </div>
                      </div>
                      <div class="row text-barlow-condensed subtitle-2">
                        Descarga el Reporte de Actividad por Curso/Sección
                      </div>
                    </div>
                  </div>
                  <div class="row px-0">
                    <div class="col-2 text-right">
                      <div class="button-container px-0">
                        <button
                          class="button secondary py-2 font-20 my-2"
                          @click="showModal.monthlyReports = true"
                        >
                          Ver
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <br />
                <div class="row mx-0">
                  <div class="col-9 row align-center">
                    <div class="col-2 text-center">
                      <unicon name="envelope" :fill="secCol"></unicon>
                    </div>
                    <div class="col-7">
                      <div class="row text-barlow-condensed subtitle text-dark">
                        Recomendar a un colega
                      </div>
                      <div class="row text-barlow-condensed subtitle-2">
                        Recomienda Beereaders a un colega
                      </div>
                    </div>
                  </div>
                  <div class="col-3 px-0 ml-n3">
                    <div class="button-container px-0">
                      <button
                        class="button secondary py-2 font-20 my-2"
                        @click="showModal.recommendation = true"
                      >
                        Recomendar
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div class="close-session-button bottom" @click="logout()">
                <a>
                  <div class="elevation-1 text-secondary">
                    <i class="fa fa-sign-out-alt"></i>
                  </div>
                  <span class="text-gray">{{ $t("closeSession") }}</span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>

    <ProfileModal v-if="showModal.profile" @close="showModal.profile = false" />
    <ReportsModal v-if="showModal.reports" @close="showModal.reports = false" />
    <MonthlyReportsModal
      v-if="showModal.monthlyReports"
      @close="showModal.monthlyReports = false"
    />
    <RecommendationModal
      v-if="showModal.recommendation"
      @close="showModal.recommendation = false"
    />
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import LanguageSwitcher from "@/components/LanguageSwitcher";
import ProfileModal from "@/components/userProfile/ProfileModal";
import ReportsModal from "@/components/userProfile/ReportsModal";
import MonthlyReportsModal from "@/components/userProfile/MonthlyReportsModal";
import RecommendationModal from "@/components/userProfile/RecommendationModal";

export default {
  name: "OffCanvas",
  components: {
    LanguageSwitcher,
    ProfileModal,
    ReportsModal,
    RecommendationModal,
    MonthlyReportsModal,
  },
  data() {
    let { secCol, grayCol } = this.$store.getters;

    return {
      secCol,
      grayCol,
      showModal: {
        profile: false,
        reports: false,
        monthlyReports: false,
        recommendation: false,
      },
    };
  },
  computed: {
    ...mapState(["showOffCanvas", "logoutUrl", "userData"]),
    ...mapState({
      quantiyPendingReports: state =>
        state.userData.pendingReportDTO.pendingReports.length,
    }),
  },
  methods: {
    ...mapMutations(["toggleOffCanvas", "logoutMutation"]),
    logout() {
      this.$store.dispatch("logout", { axios: this.axios });
    },
  },
};
</script>

<style lang="scss" scoped>
.badge,
.badge.primary {
  background: #ff2323;
  color: #fefefe;
}

#dialog-profile {
  float: right;
  width: 500px;
  background-color: white;
  min-height: 100vh;
  max-width: 100vw;
}

#off-canvas-container {
  position: fixed;
  z-index: 15;
  width: 100%;
  height: 100%;
  right: 0;
  top: 0;
  border: 0;
  overflow-y: auto;
  display: block;
  background-color: rgba(0, 0, 0, 0.5);
}

.font-2-em {
  font-size: 16px;
}

.button-container {
  border-radius: 30px;
  padding-left: 20px;
  //  box-shadow: inset 14px 0px 9px -4px rgba(170, 170, 170, 0.2);
}

.font-20 {
  font-size: 20px;
}

.close-session-button,
.close-off-panel-button {
  position: absolute !important;
  bottom: 10px !important;
  right: 10px;
  text-align: center;

  div {
    width: 70px;
    height: 70px;
    border-radius: 50px;
    text-align: center;
    padding-top: 15px;
    padding-left: 5px;
    margin: 0 auto;

    i {
      font-size: 45px;
    }

    span {
      font-size: 12px;
    }
  }
}

// @media only screen and (max-height: 700px) {
//   .close-session-button {
//     position: initial;
//     bottom: 0;
//     right: 0;
//     text-align: end;
//     margin-right: 10px;

//     div {
//       margin-right: 10px;
//     }
//   }
// }

.close-off-panel-button div {
  padding-left: 0px;
}

/* Enter and leave animations can use different */
/* durations and timing functions.              */
.slide-fade-enter-active {
  transition: all 0.3s ease;
}
.slide-fade-leave-active {
  transition: all 0.3s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateX(10px);
  opacity: 0;
}

@media print, screen and (max-width: 576px) {
  .close-off-panel-button {
    position: absolute !important;
    top: 12px;
    bottom: 0;
    right: 10px;
    text-align: center;

    div {
      width: 50px;
      height: 50px;
      border-radius: 50px;
      text-align: center;
      padding-top: 6px;
      padding-left: 0;
      margin: 0 auto;

      i {
        font-size: 35px;
      }

      span {
        font-size: 10px;
      }
    }
  }
  .menu {
    background-color: white !important;
  }
  #example-menu {
    padding: 0;
  }
  #profile-items {
    padding-top: 35px;
  }
  #dialog-profile {
    width: 100%;
  }
}
</style>
